import React from 'react';
import { steps } from '../data/content';
export function HowItWorks() {
  return <section className="bg-cream" data-id="element-94" data-mp="7slq0yyp41rl">
      <div className="mx-auto max-w-5xl px-6 py-16 lg:py-24" data-id="element-95" data-mp="7toel08jps4c">
        <h2 className="max-w-xl font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-96" data-mp="3pyrp50ha6wc5">
          Cómo funciona, paso a paso
        </h2>

        <ol className="mt-12 grid gap-10 md:grid-cols-3" data-id="element-97" data-mp="3u0d915s8gavu">
          {steps.map((step, i) => <li key={step.title} className="relative flex flex-col" data-id="element-98" data-mp="ll1wk9qt2hx9" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-99" data-mp="qibhpd75w7fa">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal font-display text-base font-semibold text-white" data-id="element-100" data-mp="ql7jxdq1li9j">
                  {i + 1}
                </span>
                <span aria-hidden="true" className="hidden h-px flex-1 bg-ink/15 md:block" data-id="element-101" data-mp="14j5v6a92gykt" />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold text-ink" data-id="element-102" data-mp="19b5nbgiwan6u">
                {step.title}
              </h3>
              <p className="mt-2 text-base leading-relaxed text-ink/70" data-id="element-103" data-mp="2rjbm5hh6d8t9">
                {step.text}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}